module.exports = __webpack_public_path__ + "static/story-e31b994824eb4758e135aa3606d6f9a7.png";